import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Input, Label, Button, Form, Alert, Toast, ToastHeader, ToastBody, Modal
    , ModalHeader, ModalBody, Badge } from "reactstrap";
import { get, post, put } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import UploadImage from "common/uploadImage";
import { ADD_ORDER, ADDRESS_TYPE, DELIVERY_TYPE_SEARCH, COUNTRIES_SEARCH, DRIVERS_SEARCH, ITEMS_SEARCH, SERVICES_SEARCH, SHIPMENT_TYPES_SEARCH,
     VEHICLE_CATEGORY_SEARCH, STATUS_SEARCH, USERS_SEARCH, UPDATE_ORDER, SHOW_ORDER, PARTNERS_SEARCH, CITIES_SEARCH, DISTRICTS_SEARCH,
    ADD_ADDRESS, SUBDISTRICTS_SEARCH, UPDATE_ADDRESS, PARTNERS_BRANCH_SEARCH, CHECK_TIMESLOT,  CATEGORIES_SEARCH, NEAREST_EXPRESS_DRIVER, EXPRESS_DRIVER_ROUTE,
    ADDRESS_SEARCH, PAYMENT_METHODS_SEARCH, PAYMENT_STATUS_SEARCH} from "helpers/api_endpoints";
import Select from "react-select";
import OrderDet from "./OrderDet";
import MapComponent from "../../components/Common/MapSelect"
import { color } from "echarts";
import ConfirmModal from "components/Common/ConfirmModal";
import { options } from "toastr";
import AddressForm from "../../components/Common/AddressForm";
import ConfirmOrderModal from "components/Common/ConfirmOrderModal";
import moment from "moment";


//meta title
document.title = "Add Order";

const AddOrder = () => {

    const expressTypes = [
        {value:0,label:'Now'},
        {value:1,label:'Booked'},
    ];
    const user = JSON.parse(localStorage.getItem('authUser')).user;
    const params = useParams();
    const [id, setId] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    //
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(0);
    const [timeslotId, setTimeslotId] = useState(null);

    //

    const [toPhone, setToPhone] = useState(null);


    const [addresses, setAddresses] = useState([]);
    const [currentAddress, setCurrentAddress] = useState([]);



    const [currentStatusId, setCurrentStatusId] = useState(1);
    const [newCurrentStatusId, setNewCurrentStatusId] = useState(0);
    const [currentStatusName, setCurrentStatusName] = useState(0);
    const [userId, setUserId] = useState(null);
    const [partnerId, setPartnerId] = useState(null);
    const [partnerBranchId, setPartnerBranchId] = useState(null);
    const [deliveryTypeId, setDeliveryTypeId] = useState(1);
    const [userName, setUserName] = useState(0);
    const [categoryId, setCategoryId] = useState(0);
    const [categoryName, setCategoryName] = useState('');
    const [countryId, setCountryId] = useState(null);
    const [countryName, setCountryName] = useState('');
    const [driverId, setDriverId] = useState(null);
    const [bookedDriverId, setBookedDriverId] = useState(null);
    const [driverName, setDriverName] = useState('');
    const [vehicleCategoryId, setVehicleCategoryId] = useState(null);
    const [addressFromId, setAddressFromId] = useState(0);
    const [addressFrom, setAddressFrom] = useState(null);
    const [driverLocation, setDriverLocation] = useState(null);
    const [addressToId, setAddressToId] = useState(0);
    const [addressTo, setAddressTo] = useState(null);
    const [expressType, setExpressType] = useState(0);
    const [refId, setrefId] = useState(null);
    const [addressToName, setAddressToName] = useState('');
    const [shipmentTypeId, setShipmentTypeId] = useState(0);
    const [shipmentTypeName, setShipmentTypeName] = useState('');
    const [shipmentTypeOptions, setshipmentTypeOptions] = useState([]);
    const [orderDate, setOrderDate] = useState(null);
    const [orderTime, setOrderTime] = useState(null);
    const [packagesNo, setPackagesNo] = useState('1');
    const [paymentMethodId, setPaymentMethodId] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [refAmount, setRefAmount] = useState(null);


    const [items, setItems] = useState([{itemId:0,quantity:0,price:0,item:{}}]);
    const [documents, setDocuments] = useState([]);
    const [timeslotDets, setTimeslotDets] = useState([]);
    const [services, setServices] = useState([{serviceId:0,quantity:0,price:0,service:{}}]);
    const [users, setUsers] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [partners, setPartners] = useState([]);
    const [partnerBranches, setPartnerBranches] = useState([]);
    const [cPartnerBranches, setCPartnerBranches] = useState([]);
    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [countries, setCountries] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [vehicleCategories, setVehicleCategories] = useState([]);
    const [shipmentTypes, setShipmentTypes] = useState([]);
    const [statues, setStatues] = useState([]);
    const [categories, setCategories] = useState([]);
    const [paymentStatuses, setPaymentStatuses] = useState([]);
    const [paymentStatusId, setPaymentStatusId] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const [msgHeader, setMsgHeader] = useState('Warning');
    const [msgBody, setMsgBody] = useState('');
    const [timeWithin, setTimeWithin] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState('Are you sure?');
    const [toastShow, setToastShow] = useState(false);
    const [showOrderConfirm, setShowOrderConfirm] = useState(false);
    const [loading, setLoading] = useState(true);


    const navigate = useNavigate();

    const loadData = () => {
        if(params.id != undefined) {
            get(`${SHOW_ORDER}/${params.id}`)
                .then(response => {
                    const order = response.data;
                    setId(params.id);
                    setUserId(order.userId);
                    setDocuments(order.document);
                    // setUserName(order.user.name);
                    setCategoryId(order.categoryId);
                    // setCategoryName(order.category.name);
                    setCountryId(order.countryId);
                    setDeliveryTypeId(order.deliveryTypeId);
                    setExpressType(order.expressType);
                    setCountryName(order.country.name);
                    setCurrentStatusId(order.currentStatusId);
                    setCurrentStatusName(order.currentStatus.name);
                    setDriverId(order.driverId);
                    setBookedDriverId(order.bookedDriverId);
                    setDriverName(order?.driver?.name);
                    setVehicleCategoryId(order.vehicleCategoryId);
                    setAddressFromId(order.addressFromId);
                    setAddressToId(order.addressToId);
                    setOrderDate(order.orderDate?.split('T')[0]);
                    setOrderTime(order.orderTime);
                    // setItems(order.orderItems);
                    // setServices(order.orderServices);
                    setrefId(order.refId);
                    setRefAmount(order.refAmount);
                    setPackagesNo(order.packagesNo);
                    setTimeslotId(order.timeSlotDetailId);
                    setDriverId(order.driverId);
                    setCurrentStatusId(order.currentStatusId);
                    setPartnerId(order.partnerId);
                    setPartnerBranchId(order.partnerBranchId);
                    setPaymentMethodId(order.paymentMethodId);
                    setPaymentStatusId(order.paymentStatusId);
                    setLoading(false);
                })
                .catch(error => {
                    console.log(error);
                    // navigate('/orders');
                })
        }
    }

    useEffect(() => {
        loadData();
        if(user.partner)
            setPartnerId(user.partner.id);
    }, [loading]);

    useEffect(() => {
        console.log('isAddressModalOpen', isAddressModalOpen)
        if(isAddressModalOpen == 1)
            setCurrentAddress(addressFromId);
        else if(isAddressModalOpen == 2)
            setCurrentAddress(addressToId);
    }, [isAddressModalOpen]);

    useEffect(() => {
        if(partnerId != 0)
            setPartnerBranches(cPartnerBranches);
    }, [partnerId]);

    useEffect(() => {
        const branch = cPartnerBranches.find(el => el.value == partnerBranchId);
        console.log('branch', branch)
        if(branch == undefined) return;
        setAddressFromId(branch.data.address.id);
        setAddressFrom(branch.data.address);
        setAddressToId(branch.data.address.id);
        setAddressTo(branch.data.address);
    }, [partnerBranchId]);

    useEffect(() => {
        getTimeSlotDets(orderDate);
    }, [partnerBranchId, orderDate]);

    const getTimeSlotDets = (tdate) => {
        const branch = cPartnerBranches.find(el => el.value == partnerBranchId);
        console.log('branch', branch?.data?.timeSlot);
        const dets = [];
        branch?.data?.timeSlot.map(el => {el.timeSlotDet.map(det => {dets.push({value: det.id, label: el.name+' , '+det.timeFrom+' - '+det.timeTo, data:det})})})
        // if(branch)
        //         setTimeslotDets(dets);
        console.log('dets', dets);
        post(CHECK_TIMESLOT, {tdate:tdate, partnerBranchId})
            .then(response => {
                console.log('resp timeslot', response.data);
                if(response?.data[0]?.timeSlotDet == undefined) return;
                setTimeslotDets(response?.data?.map(timeslot => {return timeslot.timeSlotDet.map(el => {
                    return {value: el.id, label: '(Slot: ' + timeslot.id + ') Time: ' + el.timeFrom+' - '+el.timeTo, data: el}
                })}).flat());
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {   
        post(DRIVERS_SEARCH, {deliveryTypeId: deliveryTypeId})
            .then(response => {
                setDrivers(response.data.map(el=>{
                    return {value:el.id,label:el.name + (el.expressDeliveryStatus?' (Express)':'') + (el.verifiedAll?' (Verified)':'') + ' ' + el.currentStatus, data:el}
                }));
            })
            .catch(error => {
                console.log(error)
            })
    }, [deliveryTypeId]);

    useEffect(() => {   
        post(CATEGORIES_SEARCH)
            .then(response => {
                const cats = [{value:null,label:'All Types'}];
                setCategories(cats.concat(response.data.map(el=>{
                    return {value:el.id,label:el.name}
                })));
                
            })
            .catch(error => {
                console.log(error)
            })
    }, [deliveryTypeId]);

    useEffect(() => {   
        post(PAYMENT_STATUS_SEARCH)
            .then(response => {
                setPaymentStatuses(response.data.map(el=>{
                    return {value:el.id,label:el.name}
                }));
                
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    useEffect(() => {

        post(ADDRESS_SEARCH)
            .then(response => {
                const temp = response.data.map(el=>{
                    return {value:el.id, label:el.title}
                });
                setAddresses(temp);
            })
            .catch(error => {
                console.log(error)
            })
        post(PAYMENT_METHODS_SEARCH)
            .then(response => {
                const temp = response.data.map(el=>{
                    return {value:el.id, label:el.name}
                });
                setPaymentMethods(temp);
            })
            .catch(error => {
                console.log(error)
            })
        post(DELIVERY_TYPE_SEARCH)
            .then(response => {
                setDeliveryTypes(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated}
                }));
            })
            .catch(error => {
                console.log(error)
            })
        post(PARTNERS_BRANCH_SEARCH)
            .then(response => {
                setCPartnerBranches(response.data.map(el=>{
                    return {value:el.id, label:el.name, partnerId:el.partnerId, data:el}
                }));
                setPartnerBranches(response.data.map(el=>{
                    return {value:el.id, label:el.name, partnerId:el.partnerId, data:el}
                }));
            })
            .catch(error => {
                console.log(error)
            })

        post(PARTNERS_SEARCH)
            .then(response => {
                setPartners(response.data.map(el=>{
                    return {value: el.id, label: el.name, data:el}
                }));
            })
            .catch(error => {
                console.log(error)
            })
        post(COUNTRIES_SEARCH)
            .then(response => {
                setCountries(response.data.map(el=>{
                    return {value:el.id,label:el.nameTranslated}
                }));
            })
            .catch(error => {
                console.log(error)
            })
        post(USERS_SEARCH, {role:'customer'})
            .then(response => {
                setUsers(response.data.map(el=>{
                    return {value:el.id,label:el.name}
                }));
            })
            .catch(error => {
                console.log(error)
            })
        // post(VEHICLE_CATEGORY_SEARCH)
        //     .then(response => {
        //         setVehicleCategories(response.data.map(el=>{
        //             return {value:el.id,label:el.name}
        //         }));
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
        // post(SHIPMENT_TYPES_SEARCH)
        //     .then(response => {
        //         setShipmentTypes(response.data.map(el=>{
        //             return {value:el.id,label:el.name}
        //         }));
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
        post(STATUS_SEARCH)
            .then(response => {
                setStatues(response.data.map(el=>{
                    return {value:el.id,label:el.name, notify:el.notify};
                }));
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    useEffect(() => {
        checkOrderTime();
    }, [orderTime]);

    useEffect(() => {
        getNearestDriver(driverId);
    }, [driverId]);

    const checkOrderTime = () => {
        const now = moment();
        setTimeWithin(false);
        const orderTimeStamp = moment(orderDate+' '+orderTime);
        const partnerBranch = partnerBranches.find(el => el.value == partnerBranchId);
        if(partnerBranch)
        {
            if(moment.duration(-now.diff(orderTimeStamp)).asMinutes() < partnerBranch.data.bookedAssignmentTime)
                setTimeWithin(true);
            console.log('test',partnerBranch.data.bookedAssignmentTime, moment.duration(-now.diff(orderTimeStamp)).asMinutes())
        }
    }

    const getNearestDriver = (driverId) => {
        post(EXPRESS_DRIVER_ROUTE, {lat: addressFrom?.latitude, lng: addressFrom?.longitude, driverId}).then(response => {
            let msg = '';
            if(response.code == 200)
            {
                if(!response.data)
                {
                    msg = 'Driver not available';
                    setConfirmMsg(msg)
                    return;
                }
                const min = response.data.duration?.seconds?(Math.round(response.data.duration?.seconds / 60)):' unknown ';
                setDriverLocation({duration: min});
                msg = '';
                if(driverId || timeWithin)
                    msg = "This order will be assigned immediatly. \n";
                else
                    msg = "This order is booked. \n";

                msg += 'The estimated time for driver arrival to pickup is : '+ min + ' minutes. Continue?';
                setConfirmMsg(msg)
            }
        }).catch(error => {
            console.log(error)
        });
    }

    const getNearestFromDrivers = () => {
        post(NEAREST_EXPRESS_DRIVER, {lat: addressFrom?.latitude, lng: addressFrom?.longitude}).then(response => {
            addAddressSuccess();
            if(response.code == 200)
            {
                if(!response.data)
                {
                    msg = 'No nearby driver could be found';
                    setConfirmMsg(msg)
                    return;
                }
                const min = response.data.duration?response.data.duration:' unknown ';
                setDriverLocation({duration: min});
                let msg = '';
                if(driverId || timeWithin)
                    msg = "This order will be assigned immediatly. \n";
                else
                    msg = "This order is booked. \n";
                msg += 'The estimated time for driver arrival to pickup is : '+ min + ' minutes. Continue?';
                setConfirmMsg(msg)
            }
        }).catch(error => {
            console.log(error)
        });
    }
    const handleSubmit = () => {
        if(!validateValues()) return;
        if(id != '')
        {
            put(UPDATE_ORDER, { id, categoryId, expressType, vehicleCategoryId, userId, orderTime, expectedArrivalDuration: driverLocation?.duration,bookedDriverId, deliveryTypeId
                , currentStatusId, packagesNo, addressFromId, timeSlotDetailId: timeslotId, addressToId, shipmentTypeId, shipmentTypeOptions, orderDate, items, services, countryId
                , driverId, partnerId, partnerBranchId, paymentMethodId, refAmount })
                .then(response => {
                    if (response.code == 201) {
                        navigate('/orders', { state: { successMsg: 'Added SuccessFully' } });
                    }
                })
                .catch(error => {
                    console.log(error);
                    seterrorMsg('Creation Failed');
                })            
        }
        else
        {
            post(ADD_ORDER, { categoryId:"1", countryId, vehicleCategoryId, expressType, deliveryTypeId, expectedArrivalDuration: driverLocation?.duration, bookedDriverId, orderTime
                , packagesNo, userId, partnerBranchId, timeSlotDetailId: timeslotId, customerId:userId, partnerId, countryId, currentStatusId, addressFromId, addressToId
                , orderDate, driverId, paymentMethodId, refAmount })
                .then(response => {
                    if (response.code == 201) {
                        navigate('/orders', { state: { successMsg: 'Added SuccessFully : '+response.data?.id } });
                    }
                })
                .catch(error => {
                    console.log(error);
                    seterrorMsg('Creation Failed');
                })                            
        }
    }

    const handleConfirmYes = () => {
        setCurrentStatusId(newCurrentStatusId);
        setShowConfirmModal(false);
    }

    const handleFilter = (type, value, ev='') => {
        const filtvalues = {};
        const regx1 = /^(50|52|54|55|56|58)\d{7}$/
        const regx2 = /^(02|03|04|05|06|07|08)\d{7}$/
        if (true) {console.log('value',value);
            switch (type) {
                case 'category':
                    setCategoryId(value);
                    break;
                case 'deliveryTypeId':
                    {
                        if(!countryId)
                        {
                            setToastShow(true);
                            setTimeout(function(){setToastShow(false)},2400);    
                            setMsgBody('Please select country first');
                            return;
                        }
                        setDeliveryTypeId(value);
                    }
                    break;
                case 'countryId':
                    setCountryId(value);
                    break;
                case 'vehicleCategory':
                    setVehicleCategoryId(value);
                    break;
                case 'addressFrom':
                    setAddressFromId(value);
                    break;
                case 'addressTo':
                    setAddressToId(value);
                    break;
                case 'packagesNo':
                    setPackagesNo(value);
                    break;
                case 'driverId':
                    setDriverId(value);
                    break;
                case 'countryId':
                    setCountryId(value);
                    break;
                case 'shipmentType':
                    setShipmentTypeId(value);
                    break;
                case 'currentStatusId':
                    if(driverId==0)
                    {
                        const st = statues.find(el => el.value==value);
                        // if(st.notify==1)
                        // {
                        //     setToastShow(true);
                        //     setTimeout(function(){setToastShow(false)},2400);    
                        //     setMsgBody('You must select a driver first!')    
                        // }
                        // else
                        {
                            setShowConfirmModal(true);
                            setNewCurrentStatusId(value);
                        }
                    }
                    else
                    {
                        setShowConfirmModal(true);                        
                        setNewCurrentStatusId(value);
                    }
                    break;
                case 'orderDate':
                    setOrderDate(value);
                    break;
                case 'timeslotId':
                    setTimeslotId(value);
                    break;
                case 'userId':
                    setUserId(value);
                    setPartnerId(null);
                    break;
                case 'partnerId':
                    setUserId(null);
                    setPartnerId(value);
                    break;
                case 'partnerBranchId':
                    setPartnerBranchId(value);
                    break;
                case 'paymentMethodId':
                    setPaymentMethodId(value);
                    break;
                case 'fromPhone':
                    if(ev=='') break;
                    if(regx1.test(value) || regx2.test(value))
                    {
                        setFromPhone(value);
                    }
                    else
                    {
                        setToastShow(true);
                        console.log('phone v failed')
                        setTimeout(function(){setToastShow(false)},2400);    
                        setMsgBody('Pickup Location Phone number not correct')
                    }

                    break;
                case 'toPhone':
                    // if(ev=='') break;
                    if(regx1.test(value) || regx2.test(value))
                    {
                        setToPhone(value);
                    }
                    else
                    {
                        setToastShow(true);
                        setTimeout(function(){setToastShow(false)},2400);    
                        setMsgBody('Drop Location Phone number not correct')
                        // setToPhone('');
                    }
                    break;
                default:
                    break;
            }
        }
        // setFilters(filtvalues);
    }

    const addAddressSuccess = (createdAddress) => {
        post(ADDRESS_SEARCH)
            .then(response => {
                const temp = response.data.map(el=>{
                    return {value:el.id, label:el.title + ' - ' + el.latitude + ' , ' + el.longitude}
                });
                setAddresses(temp);
                if(isAddressModalOpen == 1)
                {
                    setAddressFromId(createdAddress.id);
                    setAddressFrom(createdAddress);
                }
                else if(isAddressModalOpen == 2)
                {
                    setAddressToId(createdAddress.id);
                    setAddressTo(createdAddress);
                }

            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                setIsAddressModalOpen(0);
            })
    }

    const validateValues = () => {
        if(partnerId == null && userId == null)
        {
            console.log('check', userId, partnerId);
            setToastShow(true);
            setTimeout(function(){setToastShow(false)},2400);    
            setMsgBody('Please choose Customer or Partner');
            return false;
        }
        return true;
    }

    return (
        <React.Fragment>
            <div className="page-content">
                    <Modal size="lg" isOpen={isAddressModalOpen!=0} toggle={() => {}} zIndex={900} backdrop="static">
                    <ModalHeader >
                        Create New Address
                    </ModalHeader>
                    <ModalBody>
                        <AddressForm  mode={1} showMap={true} addressId={currentAddress} express={deliveryTypeId==1} 
                        phoneRequired={partners.find(el => el.value == partnerId)?.data?.deliveryConfirmationMethods?.includes('User OTP')}
                        onSuccess={addAddressSuccess}
                        onCancel={() => setIsAddressModalOpen(0)}
                        />
                    </ModalBody>
                    </Modal>

                <ConfirmModal
                    show={showConfirmModal}
                    onYesClick={handleConfirmYes}
                    onNoClick={() => setShowConfirmModal(false)}
                />
                <Toast isOpen={toastShow} fade={true} className="position-fixed end-0 p-3 bg-warning" style={{"bottom":"3px", "z-index":"111", "margin":"10px"}}>
                    <ToastHeader>
                        {msgHeader}
                    </ToastHeader>
                    <ToastBody>
                        {msgBody}
                    </ToastBody>
                </Toast>
                <ConfirmOrderModal show={showOrderConfirm} msg={confirmMsg} onNoClick={()=>{setShowOrderConfirm(false)}} onYesClick={()=>{handleSubmit()}} />
                <div className="container-fluid">
                    <Breadcrumbs title="Items" breadcrumbItem={params.id==undefined?"Add Order":"Edit Order"} />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            // if(!driverId)
                                // getNearestFromDrivers();
                            setShowOrderConfirm(true);
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

                                            <CardBody>
                                            <Row>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Country</Trans></Label>
                                                    <Select
                                                    isDisabled={deliveryTypeId==3}
                                                    name="deliveryTypeId"
                                                    value={countries.find(option => {return countryId==option.value}) || null}
                                                    options={countries} 
                                                    className="form-control "
                                                    onChange={(e) => handleFilter('countryId', e.value)}
                                                    required
                                                    />
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Delivery Type</Trans></Label>
                                                    <Select
                                                    isDisabled={user.partner || deliveryTypeId==3}
                                                    name="deliveryTypeId"
                                                    value={deliveryTypes.filter(option => {return deliveryTypeId==option.value})}
                                                    options={deliveryTypes} 
                                                    className="form-control "
                                                    onChange={(e) => handleFilter('deliveryTypeId', e.value)}
                                                    />
                                                </div>
                                                {deliveryTypeId == 1?(
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Vehicle Type</Trans></Label>
                                                    <Select
                                                    isDisabled={deliveryTypeId==3}
                                                    name="vehicleCategoryId"
                                                    value={categories.filter(option => {return vehicleCategoryId==option.value})}
                                                    options={categories} 
                                                    className="form-control select2"
                                                    onChange={(e) => setVehicleCategoryId(e.value)}
                                                    />
                                                </div>
                                                ):<></>}
                                                {/* {deliveryTypeId == 1 && !user.partner?(
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Express Type</Trans></Label>
                                                    <Select
                                                    name="expressType"
                                                    value={expressTypes.filter(option => {return expressType==option.value})}
                                                    options={expressTypes} 
                                                    className="form-control select2"
                                                    onChange={(e) => setExpressType(e.value)}
                                                    />
                                                </div>
                                                ):<></>} */}
                                                <div className="form-group col-md-6 mt-2" style={{boxShadow:"0px 1px 2px 0px orange", padding:"3px"}}>
                                                    <Row>
                                                    {!user.partner?(
                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Customer</Trans></Label>
                                                            <Select
                                                            isDisabled={deliveryTypeId==3 && params.id != undefined}
                                                            name="userId"
                                                            options={users} 
                                                            value={users.filter(option => {return userId==option.value})}
                                                            className="form-control select2"
                                                            onChange={(e) => handleFilter('userId', e.value)}
                                                            />
                                                        </div>
                                                    ):<></>}
                                                        {!user.partner?(
                                                            <div className="form-group col-md-4 mt-2">
                                                                <Label className="form-label"><Trans>Partner</Trans></Label>
                                                                <Select
                                                                isDisabled={deliveryTypeId==3 && params.id != undefined}
                                                                name="partnerId"
                                                                options={partners} 
                                                                value={partners.filter(option => {return partnerId==option.value})}
                                                                className="form-control select2"
                                                                onChange={(e) => handleFilter('partnerId', e.value)}
                                                                />
                                                            </div>

                                                        ):<></>}

                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Partner Branch</Trans></Label>
                                                            <Select
                                                            isDisabled={deliveryTypeId==3 && params.id != undefined}
                                                            name="partnerId"
                                                            options={partnerBranches.filter(option => {return partnerId==option.partnerId})} 
                                                            value={partnerBranches.filter(option => {return partnerBranchId==option.value})}
                                                            className="form-control select2"
                                                            onChange={(e) => handleFilter('partnerBranchId', e.value)}
                                                            required={user.partner?true:false}
                                                            />
                                                        </div>

                                                    </Row>
                                                </div>
                                                {deliveryTypeId == 1 && !driverId ?(
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Row>
                                                            <div className="form-group col-md-6 mt-2">
                                                                <Label className="form-label"><Trans>Date</Trans></Label>
                                                                <Input
                                                                isDisabled={deliveryTypeId==3}
                                                                name="orderDate"
                                                                value={orderDate}
                                                                className="form-control"
                                                                placeholder="Enter Date "
                                                                type="date"
                                                                onChange={(e) => handleFilter('orderDate', e.target.value)}
                                                                
                                                                ></Input>
                                                            </div>
                                                            <div className="form-group col-md-6 mt-2">
                                                            <Label className="form-label"><Trans>Time</Trans></Label>
                                                            <Input
                                                            isDisabled={deliveryTypeId==3}
                                                            name="orderTime"
                                                            value={orderTime}
                                                            className="form-control"
                                                            placeholder="Enter Time "
                                                            type="time"
                                                            onChange={(e) => setOrderTime(e.target.value)}
                                                            
                                                            ></Input>
                                                            </div>
                                                        </Row>
                                                        <small> “If you do not fill in the date and time, this order will be processed immediately.”</small>
                                                    </div>
                                                ):<></>}
                                                {deliveryTypeId != 1 && !user.partner?(
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Time Slot</Trans></Label>
                                                        <Select
                                                        isDisabled={deliveryTypeId==3}
                                                        name="timeslotId"
                                                        options={timeslotDets} 
                                                        value={timeslotDets?.filter(option => {return timeslotId==option.value})}
                                                        className="form-control select2"
                                                        onChange={(e) => handleFilter('timeslotId', e.value)}
                                                        />
                                                    </div>

                                                ):<></>}
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Packages Number</Trans></Label>
                                                    <Input
                                                    disabled={deliveryTypeId==3 && params.id != undefined?'disabled':''}
                                                    name="packagesNo"
                                                    value={packagesNo}
                                                    className="form-control"
                                                    placeholder="Enter Date "
                                                    type="number"
                                                    onChange={(e) => handleFilter('packagesNo', e.target.value)}
                                                    ></Input>
                                                </div>
                                                {!user.partner && !orderDate && !orderTime || deliveryTypeId == 3?(
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Driver</Trans></Label>
                                                        <Select
                                                        name="driverId"
                                                        value={drivers.filter(option => {return driverId==option.value})}
                                                        options={vehicleCategoryId?drivers.filter(el => el.data.vehicle[0]?.vehicleCategoryId == vehicleCategoryId):drivers} 
                                                        className="form-control select2"
                                                        onChange={(e) => handleFilter('driverId', e.value)}
                                                        />
                                                        {driverLocation?(
                                                            <div style={{marginTop:"5px"}}>
                                                                {/* <a target="_blank" rel="noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${driverLocation.driverLocation.latitude},${driverLocation.driverLocation.longitude}`}></a> */}
                                                                <h7 style={{color:"blue"}}>Driver arrival time estimated: {driverLocation?.duration} minutes</h7>  
                                                            </div>
                                                        ):<></>}
                                                    </div>
                                                ):<></>}

                                                {/* <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Booked Driver</Trans></Label>
                                                    <Select
                                                    name="bookedDriverId"
                                                    value={drivers.filter(option => {return bookedDriverId==option.value})}
                                                    options={drivers} 
                                                    className="form-control select2"
                                                    onChange={(e) => setBookedDriverId(e.value)}
                                                    disabled
                                                    />
                                                </div> */}
                                                {/* <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Shipment Type</Trans></Label>
                                                    <Select
                                                    name="shipmentTypeId"
                                                    value={shipmentTypes.filter(option => {return shipmentTypeId==option.value})}
                                                    options={shipmentTypes} 
                                                    className="form-control select2"
                                                    onChange={(e) => handleFilter('shipmentType', e.value)}
                                                    />
                                                </div> */}


                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <Select
                                                    isDisabled={user.partner || deliveryTypeId==3}
                                                    name="currentStatusId"
                                                    value={statues.filter(option => {return currentStatusId==option.value})}
                                                    options={statues} 
                                                    className="form-control select2"
                                                    onChange={(e) => handleFilter('currentStatusId', e.value)}
                                                    />
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Reference</Trans></Label>
                                                    <h4><Badge className="bg-primary"> {refId} </Badge></h4>
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Payment Method</Trans></Label>
                                                    <h4><Badge className="bg-primary"> {paymentMethodId} </Badge></h4>
                                                    <Select
                                                    isDisabled={deliveryTypeId==3 && refId}
                                                    name="paymentMethodId"
                                                    value={paymentMethods.find(option => {return paymentMethodId==option.value})}
                                                    options={paymentMethods} 
                                                    className="form-control select2"
                                                    onChange={(e) => handleFilter('paymentMethodId', e.value)}
                                                    required
                                                    />
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Payment Status</Trans></Label>
                                                    <h4><Badge className="bg-primary">  </Badge></h4>
                                                    <Select
                                                    isDisabled={true}
                                                    name="paymentStatus"
                                                    value={paymentStatuses.find(option => {return paymentStatusId==option.value})}
                                                    options={paymentStatuses} 
                                                    className="form-control select2"
                                                    onChange={(e) => handleFilter('paymentMethodId', e.value)}
                                                    />
                                                </div>
                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Order Amount</Trans></Label>
                                                    <h4><Badge className="bg-primary">  </Badge></h4>
                                                    <Input
                                                    disabled={deliveryTypeId==3 && refId}
                                                    name="refAmount"
                                                    value={refAmount}
                                                    className="form-control"
                                                    placeholder="Enter Amount "
                                                    type="number"
                                                    onChange={(e) => handleFilter('refAmount', e.target.value)}
                                                    ></Input>
                                                </div>
                                                <Row>
                                                    <div className="form-group col-md-5 mt-2" style={{backgroundColor:'#8de',padding:'15px'
                                                    ,boxShadow:'0 0 5px #8de', borderRadius:'10px'}}>
                                                        <Label className="form-label"><Trans>From Address</Trans></Label>
                                                        <Select
                                                        isDisabled={deliveryTypeId==3 && refId}
                                                        name="addressFromId"
                                                        value={addresses.filter(el => el.value==addressFromId)}
                                                        options={addresses} 
                                                        className="form-control select2"
                                                        onChange={(e) => handleFilter('addressFrom', e.value)}
                                                        />
                                                        <Button 
                                                        onClick={() => setIsAddressModalOpen(1)} color="secondary"
                                                        disabled={deliveryTypeId==3 && refId?'disabled':''}
                                                        >Create Address +</Button>
                                                        <div className="form-group col-md-12 mt-2">
                                                            <AddressForm  mode={1} showMap={true} addressId={addressFromId} showControls={false} express={deliveryTypeId==1}
                                                            onSuccess={(address) => {console.log('address', address);}}
                                                            onCancel={() => setIsAddressModalOpen(0)}
                                                            showDets={false}
                                                            />
                                                        </div>
                                                    </div>                                          

                                                    <div className="form-group col-md-5 mt-2" style={{backgroundColor:'silver',padding:'15px'
                                                        ,boxShadow:'0 0 5px silver', borderRadius:'10px', marginLeft:'25px'}}>
                                                        <Label className="form-label"><Trans>To Address</Trans></Label>
                                                        <p>District {addresses.filter(el => el.value==addressToId).districtId}</p>
                                                        <Select
                                                        isDisabled={deliveryTypeId==3 && refId}
                                                        name="addressToId"
                                                        value={addresses.filter(el => el.value==addressToId)}
                                                        options={addresses} 
                                                        className="form-control select2"
                                                        onChange={(e) => handleFilter('addressTo', e.value)}
                                                        required
                                                        />
                                                        <Button 
                                                        onClick={() => setIsAddressModalOpen(2)} color="secondary"
                                                        disabled={deliveryTypeId==3 && refId?'disabled':''}
                                                        >Create Address +</Button>
                                                        <div className="form-group col-md-12 mt-2">
                                                            <AddressForm  mode={1} showMap={true} addressId={addressToId} showControls={false} express={deliveryTypeId==1}
                                                            onSuccess={(address) => {console.log('address', address);}}
                                                            onCancel={() => setIsAddressModalOpen(0)}
                                                            showDets={false}
                                                            />
                                                        </div>
                                                    </div> 
                                                </Row>                                         

                                            </Row>
                                            </CardBody>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            /*Do not delete */
                        }
                        {/* <Card>
                            <CardBody>
                                {items.map((item,index) => (
                                    <div data-test={item.itemId} key={index}>
                                        <OrderDet type="item" item={item} />
                                    </div>

                                ))}
                                <div className="mt-4">
                                    <Button type="button" color="info" onClick={ e => {e.preventDefault()
                                                                                items.push({itemId:0,quantity:0,price:0,item:{}})
                                                                                setUpdate(Math.random())}}>
                                        <Trans>Add</Trans>
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                {services.map((service,index) => (
                                    <div key={index}>
                                        <OrderDet type="service" item={service} />
                                    </div>

                                ))}
                                <div className="mt-4">
                                    <Button type="button" color="info" onClick={ e => {e.preventDefault()
                                                                                services.push({serviceId:0,quantity:0,price:0,service:{}})
                                                                                setUpdate(Math.random())}}>
                                        <Trans>Add</Trans>
                                    </Button>
                                </div>
                            </CardBody>
                        </Card> */}
                        <div className="row">
                            {
                                documents.map((doc, index) => (
                                    <div className="form-group col-md-4 mt-2 text-center" key={index}>
                                        <p>{doc.name}</p>
                                        <h5>{doc.type==4?'Payment confirmation':''}</h5>
                                        <img src={doc.filePath} width="80%" height="570" />
                                    </div>

                                ))

                            }
                        </div>
                        <div className="mt-4">
                                            <Button type="submit" color="primary">
                                                <Trans>Submit</Trans>
                                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddOrder
